// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"DisabledStateTooltip__tooltipContainer___owaPJ","message":"DisabledStateTooltip__message___ui_So"};